<div (click)="toggleOpen()" class="ibox-title collapse-link">
  <h5>{{ title }}</h5>
  <div class="ibox-tools">
    <fa-icon [icon]="faChevronDown" [hidden]="!section.open"></fa-icon>
    <fa-icon [icon]="faChevronUp" [hidden]="section.open"></fa-icon>
  </div>
</div>
